module.exports = __webpack_public_path__ + "img/3-7.0d2aa4a9.jpg";